import { useMutation } from "react-query";
import useApi from "utils/api/useApi";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "store";
import { RootState } from "store/reducers";

export const useGetItemClassDetail = () => {
  const dispatch = useDispatch();
  const itemClassDetail = useSelector(
    (state: RootState) => state.PreFillData.product_type_detail
  );
  const api = useApi();
  const getProductTypeDetail = async (producttype_id: number) => {
    const res = await api
      .path("item_class/detail", { item_class_id: producttype_id })
      .get();
    dispatch(
      Actions.PreFillData.update({
        key: "product_type_detail",
        value: res?.data?.data,
      })
    );
    return res?.data?.data;
  };

  const { isLoading, error, mutate } = useMutation((producttype_id: number) =>
    getProductTypeDetail(producttype_id)
  );

  return {
    getItemClassDetailData: itemClassDetail,
    getItemClassDetailError: error,
    getItemClassDetailLoading: isLoading,
    getItemClassDetailMutate: mutate,
  };
};
